import React from "react";
import { Link } from "react-router-dom";
// @ts-ignore
import "./FleetSection.css";

interface FleetItem {
  key: string;
  img: string;
  name: string;
  desc: string;
  features: string[];
}

const fleet: FleetItem[] = [
  {
    key: "LUXURY SEDAN",
    img: `${process.env.PUBLIC_URL}/images/sedan-v2.webp`,
    name: "Executive Luxury Sedan",
    desc: "Ideal for airport transfers, corporate meetings, and point-to-point rides. Smooth, comfortable, and executive.",
    features: ["Seating capacity shared on request", "Leather Interior", "Climate Control"],
  },
  {
    key: "FULL SUV",
    img: `${process.env.PUBLIC_URL}/images/suv-v2.webp`,
    name: "Luxury SUV",
    desc: "Perfect for group airport transfers, family travel, and VIP corporate travel. Extra luggage capacity and plenty of room.",
    features: ["Seating details provided when you book", "Privacy Glass", "WiFi Ready"],
  },
  {
    key: "SPRINTER",
    img: `${process.env.PUBLIC_URL}/images/benz-sprinter-v2.webp`,
    name: "Executive Mercedes-Benz Sprinter",
    desc: "Premium group travel for events, corporate outings, and large family transfers.",
    features: ["Group capacity outlined for your trip", "High Roof", "Leather Captain Chairs"],
  },
];

export default function FleetSection(): JSX.Element {
  return (
    <section className="fleet-section py-5" id="fleet">
      <div className="container">
        <div className="text-center mb-5 gs-anim">
          <span className="section-badge">Our Fleet</span>
          <h2 className="section-title">Ride in Style</h2>
          <p className="section-sub">
            Choose from our meticulously maintained luxury fleet — each car a
            statement of elegance and professionalism.
          </p>
        </div>
        <div className="row g-4">
          {fleet.map((car, i) => (
            <div className="col-12 col-md-4 gs-anim" key={i}>
              <div className="fleet-card h-100">
                <div className="fleet-img-wrap">
                  <img
                    src={car.img}
                    srcSet={`${car.img.replace(/\.webp$/, "-420.webp")} 420w, ${
                      car.img.replace(/\.webp$/, "-700.webp")
                    } 700w, ${car.img} 840w`}
                    sizes="(min-width: 768px) 230px, calc(100vw - 40px)"
                    alt={`GS Limo Elite ${car.name} — luxury transportation`}
                    title={`GS Limo Elite ${car.name} — luxury transportation`}
                    className="fleet-img"
                    width="840"
                    height="469"
                    loading="lazy"
                  />
                  <div className="fleet-img-overlay"></div>
                </div>
                <div className="fleet-body mb-3">
                  <h3 className="fleet-name">{car.name}</h3>
                  <p className="fleet-desc">{car.desc}</p>
                  <div className="fleet-features">
                    {car.features.map((f, j) => (
                      <span className="fleet-feature" key={j}>
                        <i className="fas fa-check-circle"></i> {f}
                      </span>
                    ))}
                  </div>
                  <Link
                    to="/get-a-quote"
                    state={{ vehicle: car.key }}
                    className="btn gs-btn-gold w-100 mt-auto"
                    title={`Book the ${car.name}`}
                  >
                    Book This Vehicle
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>
        <div className="text-center mt-5 gs-anim">
          <Link
            to="/fleet"
            className="btn gs-btn-outline-gold"
            title="View Our Full Fleet"
          >
            <i className="fas fa-car me-2"></i> View Full Fleet
          </Link>
        </div>
      </div>
    </section>
  );
}
